import React from 'react';
import { navigate } from 'gatsby';

import { LinkHasPermissionOptions, useLinkHasPermission } from './useLinkHasPermission';

export type PermissionedNavigate = (to: string, options?: LinkHasPermissionOptions) => void;

export const usePermissionedNavigate = (): PermissionedNavigate => {
  const { linkHasPermission } = useLinkHasPermission();
  const permissionedNavigate: PermissionedNavigate = React.useCallback(
    (to: string, options) => {
      if (!linkHasPermission(to, options)) {
        return;
      }

      navigate(to);
    },
    [linkHasPermission]
  );

  return permissionedNavigate;
};
